module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-600.faf15010.woff2";